import { render, staticRenderFns } from "./BotaoSalvar.vue?vue&type=template&id=ce1836a2"
import script from "./BotaoSalvar.vue?vue&type=script&lang=js"
export * from "./BotaoSalvar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports